import "react-toastify/dist/ReactToastify.css";

import React from "react";
import { Slide, toast, ToastContainer } from "react-toastify";

export const customToast = {
    warn: (message: string | React.ReactNode) => toast.warn(message),
    success: (message: string | React.ReactNode) => toast.success(message),
    error: (message: string | React.ReactNode) => {
        return message && toast.error(message);
    },
};

const NotifyContainer = () => {
    return (
        <ToastContainer
            containerId={"notify-container"}
            position='bottom-left'
            limit={3}
            autoClose={3000}
            hideProgressBar={true}
            closeOnClick
            pauseOnFocusLoss
            draggable={false}
            pauseOnHover
            transition={Slide}
            theme='colored'
        />
    );
};
export default NotifyContainer;
